module.exports = __webpack_public_path__ + "img/macos.4b687826.svg";